<div>
  <ion-header>
    <ion-toolbar color="light">
      <ion-title>Comment</ion-title>
    </ion-toolbar>
  </ion-header>
  <div class="comment-wrapper">
    <ion-item>
      <ion-label position="floating">Add Comment...</ion-label>
      <ion-textarea [(ngModel)]="comment"></ion-textarea>
    </ion-item>
    <div class="comment-buttons">
      <ion-button size="small" (click)="onClickCancel()">{{'CANCEL'|translate}}</ion-button>
      <ion-button size="small" (click)="onClickSave()">{{'SAVE'|translate}}</ion-button>
    </div>
  </div>
</div>
